import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LightingStudio from './pages/LightingStudio';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Admin from './pages/Admin';
import Pricing from './pages/Pricing';
import BillingSuccess from './pages/BillingSuccess';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Refund from './pages/Refund';
import Contact from './pages/Contact';
import About from './pages/About';
import ProtectedRoute from './components/ProtectedRoute';
import AnonAuthGate from './components/AnonAuthGate';
import { AuthProvider } from './contexts/AuthContext';
import { useSessionTracker } from './hooks/useSessionTracker';
import './App.css';

function AppRouter() {
  useSessionTracker();
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<LightingStudio />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Routes>
      <AnonAuthGate />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
